import {styled} from "@mui/material";
import { getIconsByType, iconTypes } from '@services/icons';

const EnabledIcon = getIconsByType(iconTypes.CIRCLE_CHECKMARK_OVERFLOWED);
const DisabledIcon = getIconsByType(iconTypes.RADIO_OFF);

export const DescriptionArea = styled('div')(
  {
    paddingBottom: 15,
    marginBottom: 15,
    lineHeight: '19px',
  },
  ({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.novotalk.$resourcesTableBorderColor}`,
  })
);

export const TitleContainer = styled('div')({
  marginBottom: 10,
});

export const SkipPollStatusContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const StyledSkipPollEnabledIcon = styled(EnabledIcon)(
  ({ theme }) => ({
    color: theme.palette.novotalk.$completedColor,
  })
);

export const StyledSkipPollDisabledIcon = styled(DisabledIcon)(
  ({ theme }) => ({
    color: theme.palette.novotalk.$navigationNotificationColor,
  })
);
